<template>
  <div>
    <el-dialog
      :title="$t('publishListings.Update')"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" :model="formObj" ref="formObj" class="dialog-box">
        <div class="explain">
          {{ platformCode === 'SP' ? $t('Publish.ProductList.Components.BatchListToStoreModal.SPExplain') : $t('Publish.ProductList.Components.BatchListToStoreModal.Explain')}}
        </div>
        <el-form-item :label="$t('Publish.ProductList.Components.BatchListToStoreModal.SizeUnit')" style="margin-bottom: 10px">
          <el-radio-group v-model="formObj.sizeUnit">
            <el-radio :label="'cm'">cm</el-radio>
            <el-radio :label="'inch'">inch</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item required style="margin-bottom: 10px">
          <template slot="label">
            <span>{{ $t('Publish.ProductList.Components.BatchListToStoreModal.SuggestedPrice') }}</span>
              <el-tooltip effect="dark" :content="`${$t('productList.priceTips')}`" placement="top-start">
                <i class="el-icon-warning-outline pointer" style="margin-left: 5px;"></i>
              </el-tooltip>
          </template>
          <div>
            KakaClo {{ $t('productList.Price') }}
            <el-select v-model="formObj.priceRatioType" style="width:90px">
              <el-option label="x" value="x"></el-option>
              <el-option label="+" value="+"></el-option>
            </el-select>
            <el-input v-model="formObj.priceRatio" style="width: 200px;margin: 0 10px" placeholder="0" v-toFloat class="noRound">
              <template slot="append">{{ formObj.priceRatioType === 'x' ? 'Profit Margin' : 'Profit' }}</template>
            </el-input>
            <span>+ {{ $t('Publish.ProductList.Components.BatchListToStoreModal.ShippingCost') }}</span>
            <span>= {{ $t('Publish.ProductList.Components.BatchListToStoreModal.SugestPrice') }}</span>
          </div>
          <!-- <div style="color: red" v-if="formObj.priceRatio > 20">{{ $t('productList.priceRatioGT20Tip') }}</div> -->
          <div style="color: red" v-if="formObj.priceRatioType === 'x' && formObj.priceRatio > 20">{{ $t('productList.priceRatioGT20Tip') }}</div>
        </el-form-item>

        <el-form-item style="margin-bottom: 10px" v-if="platformCode !== 'TT'">
          <template slot="label">
            <span>{{ $t('Publish.ProductList.Components.BatchListToStoreModal.CompareAtPrice') }}</span>
          </template>
          <div :class="{'actual-price': setPriceTips}">
            KakaClo {{ $t('productList.Price') }}
            <el-select v-model="formObj.compareAtPriceRatioType" style="width:90px">
              <el-option label="x" value="x"></el-option>
              <el-option label="+" value="+"></el-option>
            </el-select>
            <el-input v-model="formObj.compareAtPriceRatio" style="width: 200px;margin: 0 10px" placeholder="0" v-toFloat class="noRound">
              <template slot="append">{{ formObj.compareAtPriceRatioType === 'x' ? 'Profit Margin' : 'Profit' }}</template>
            </el-input>
            <span>+ {{ $t('Publish.ProductList.Components.BatchListToStoreModal.ShippingCost') }}</span>
            <span>= {{ $t('Publish.ProductList.Components.BatchListToStoreModal.CompareAtPrice') }}</span>
          </div>
          <div style="color: #EB5757;" v-if="setPriceTips">{{ $t('Publish.ProductList.Components.BatchListToStoreModal.Tips1') }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('productList.Cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('productList.ListNow') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
const formObj = {
  sizeUnit: 'inch',
  priceRatioType: 'x',
  compareAtPriceRatioType: 'x'
}
export default {
  props: {
    platformCode: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      formObj: _.cloneDeep(formObj)
    }
  },
  directives: {
    toFloat: {
      inserted: function(el) {
        const input = el.querySelector('.el-input__inner')
        input.oninput = function(e) {
          let value = input.value.replace(/[^\d.]/g, '')
          input.value = value
        }
        input.onblur = () => {
          let value = parseFloat(input.value)
          if (Number.isNaN(value) || value <= 1) {
            value = null
          } else {
            value = parseFloat(value.toFixed(2))
          }
          input.value = value
        }
      }
    }
  },
  computed: {
    setPriceTips() {
      if (!this.formObj.priceRatio || !this.formObj.compareAtPriceRatio) {
        return false
      } else {
        return Number.parseFloat(this.formObj.compareAtPriceRatio) <= Number.parseFloat(this.formObj.priceRatio)
      }
    }
  },
  methods: {
    show(ids) {
      this.formObj.ids = ids
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.formObj.resetFields()
      this.formObj = _.cloneDeep(formObj)
      this.dialogVisible = false
    },
    submit() {
      this.formObj.platformCode = this.platformCode
      API.publishBatchUpdateListing(this.formObj).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.dialogVisible = false
        this.$emit('updateSuccess', 'update')
      })
    }
  },
  watch: {
    'formObj.priceRatioType'(newVal) {
      this.formObj.compareAtPriceRatioType = newVal
    },
    'formObj.compareAtPriceRatioType'(newVal) {
      this.formObj.priceRatioType = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-box {
  .explain {
    margin-bottom: 20px;
    font-size: 16px;
  }

  .actual-price {
    /deep/.el-input__inner,
    /deep/.el-input-group__append {
      border-color: #EB5757;
    }
  }

  .noRound {
    /deep/.el-input__inner{
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    /deep/.el-input-group__append{
      background-color: #fff;
    }
  }

  /deep/ .el-select .el-input input{
    border-radius: 4px !important;
  }
}
</style>
